<template>
  <div class="lab" v-if="lab">
    <div class="heading">
      <h1>{{lab.name}}</h1>
      <div v-if="lab.userId != 0">
        <app-btn
          @click="edit()"
        >
          {{$ml.get(`edit`)}}
        </app-btn>
        <app-btn
          styling="outline"
          @click="deleteLab()"
        >
          {{$ml.get(`delete`)}}
        </app-btn>
      </div>
    </div>

    <general :lab="lab" />
    <nutrients :extractionMethods="extractionMethods" :nutrientTypes="nutrientTypes" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import General from "@/components/labs/General"
import Nutrients from "@/components/labs/Nutrients"

export default {
  props: {
    value: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      lab : 'labs/lab',
      extractionMethods : 'labs/methods',
      nutrientTypes : 'nutrients/topLevelNutrients',
    })
  },
  methods: {
    sync(id) {
      console.log(id);
      this.$store.dispatch('labs/getLab', id);
      this.$store.dispatch('labs/getMethods', id);

      [].forEach.call(document.querySelectorAll('.nutrient'), el => { //collapse all nutrients when user select another lab
          el.classList.remove('is_active');
          console.log(el);
      });

      // console.log(this.lab, this.extractionMethods, this.nutrientTypes);
    },
    expand(i) {
      this.$refs['nutrient-'+i][0].classList.toggle('is_active');
    },
    edit () {
      this.$store.dispatch('labs/popup/open', {open: true, isNew: false});
    },
    deleteLab () {
      this.$store.commit('modals/prompt/open', {
        onAccept: () => {
          this.$store.dispatch('labs/popup/delete').then(res => {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(`Lab successfully deleted!`),
              type : 'Success',
            });

            this.$store.dispatch('labs/loadLabs').then(res => {
              this.$router.push('/dashboard/labs');
            });
          });
        },
        text: this.$ml.get('tips.Are you sure want to remove this lab?'),
      });
    }
  },
  watch: {
    value() {
      this.sync(this.value);

    }
  },
  created() {
    if(this.value) {
      this.sync(this.value);
    }
  },
  components: {
    General,
    Nutrients
  }

}
</script>

<style lang="scss" scoped>
.lab {
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;

    >div:last-child {
      display: flex;
      align-items: center;

      >button {
        margin: 5px;
      }
    }
  }

  .tab {
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 8px;
    h2 {
      background-color: $mainGreen;
      padding: 8px 16px;
      margin: 0;
      font-weight: 500;
      font-size: 14px;
      letter-spacing: .5px;
      color: #fff;
      text-transform: uppercase;
    }
    .content {
      padding: 16px;
      // background-color: #fff;
      flex-grow: 1;
      &.columns {
        display: flex;
        flex-direction: row;
        .a-column {
          flex-basis: calc(33% - 16px);
          margin: 0 8px;
          color: #4C5056;
          h3 {
            margin: 0 0 12px 0;
            font-size: 13px;
            font-weight: 400;

          }
          p {
            margin: 0;
            font-weight: 500;
            font-size: 16px;
          }
        }
      }
      &.nutrients {
        .nutrient {
          // padding: 8px 0;
          .nutrient-name {
            padding: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            border-bottom: 1px solid #E4E5E6;
            h3 {
              color: $mainGreen;
              font-size: 18px;
              margin: 0;
            }
            .icon {
              width: 30px;
              height: 24px;
              position: relative;
              color: $mainGreen;
              font-weight: 400;
              font-size: 24px;
              &:before {
                content: '+';
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%,-50%);
              }
            }
          }
          .methods {
            height: 0;
            transition: .3s;
            overflow: hidden;
            .a-row {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              padding: 16px;
              border-bottom: 1px solid #E4E5E6;
              .sat-method {
                flex-basis: 35%;
              }
              .low, .adequate, .high {
                flex-basis: 20%;
              }
              &.titles {
                > div {
                  text-transform: uppercase;
                  font-size: 12px;
                  font-weight: 600;
                  color: #4C5056;
                  &.low {
                    color: #5EC19B;
                  }
                  &.adequate {
                    color: #A7B975;
                  }
                  &.high {
                    color: #F2B14E;
                  }
                }
              }
            }
          }
          &.is_active {
            .icon {

              &:before {
                content: '-'
              }
            }
            .methods {
              height: auto;
              overflow: visible;
            }
          }
        }

      }
    }
  }
}
</style>
